import cn from 'classnames';

import styles from './ReCaptchaLabel.module.scss';

export default function ReCaptchaLabel({ inFooter = false }) {
  return (
    <div aria-hidden className={cn(styles.root, inFooter && styles.inFooter)}>
      This site is protected by reCAPTCHA and the Google&nbsp;
      <a href="https://policies.google.com/privacy" rel="noopener noreferrer" target="_blank">
        Privacy Policy
      </a>{' '}
      and&nbsp;
      <a href="https://policies.google.com/terms" rel="noopener noreferrer" target="_blank">
        Terms of Service
      </a>{' '}
      apply.
    </div>
  );
}
